// extracted by mini-css-extract-plugin
export default {"formm":"Review-form_formm__GHs2o","invalid":"Review-form_invalid__32yFz","error-text":"Review-form_error-text__SFggt"};